import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dropdown" }
const _hoisted_2 = ["aria-expanded"]
const _hoisted_3 = ["onClick"]

import { DropdownItem } from '@/types';
import { onBeforeMount, onBeforeUnmount, reactive, ref } from 'vue';
import { useI18n } from 'vue-i18n';

interface Props {
  label: string;
  items: DropdownItem[];
}

interface State {
  open: boolean;
}

/* Props */

export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownComponent',
  props: {
    label: null,
    items: null
  },
  emits: ['onChanged'],
  setup(__props: any, { emit }) {

const { t } = useI18n();

/* Interface */


/* Reactive */
const state = reactive<State>({
  open: false,
});

/* Refs */
const dropdownMenu = ref<HTMLElement>();
const toggle = ref<HTMLElement>();

/* Emits */


/* Functions */
const toggleVisibility = () => (state.open = !state.open);

const onSelect = (value: string) => {
  toggleVisibility();
  emit('onChanged', value);
};

const autoClose = (event: any) => {
  if (
    !dropdownMenu.value?.contains(event.target) &&
    !toggle.value?.contains(event.target) &&
    state.open
  ) {
    toggleVisibility();
  }
};

/* Lifecycle hooks*/
onBeforeMount(() => document.addEventListener('click', autoClose));
onBeforeUnmount(() => document.removeEventListener('click', autoClose));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "dropdown__toggle",
      onClick: toggleVisibility,
      "aria-haspopup": "true",
      "aria-expanded": state.open,
      ref_key: "toggle",
      ref: toggle
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$props.label), 1)
    ], 8, _hoisted_2),
    (state.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "dropdown__menu",
          ref_key: "dropdownMenu",
          ref: dropdownMenu
        }, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.value
              }, [
                _createElementVNode("a", {
                  class: "dropdown__item",
                  href: "#",
                  onClick: _withModifiers(($event: any) => (onSelect(item.value)), ["prevent","stop"])
                }, _toDisplayString(_unref(t)(item.label)), 9, _hoisted_3)
              ]))
            }), 128))
          ])
        ], 512))
      : _createCommentVNode("", true)
  ]))
}
}

})